export default {
  system: {
    SystemId: 'System Id',
    SystemCode: 'System Code',
    SystemName: 'System Name',
    Effective: 'Effective',
    StatusCanNotEmpty: 'Status Can Not Empty',
    SystemNameCanNotEmpty: 'System Name Can Not Empty',
    SystemCodeCanNotEmpty: 'System Code Can Not Empty'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/base/system.js